import LayoutDesktop from './layoutDesktop/LayoutDesktop';
import useAppPublicCustomisations from '@/hooks/useAppPublicCustomisations';
import Loader from '@/components/loader/Loader';

/**
 * PublicLayout is separated into mobile and desktop layouts.
 *
 * This is due to the mobile application having a different UI and utilizing the same routes from this web application.
 * In other words, only affecting public pages.
 *
 * You can see this behaviour in the ForgotPassword and Login component pages.
 */
const PublicLayout = () => {
  const { isCustomisationsLoading } = useAppPublicCustomisations();

  if (isCustomisationsLoading) {
    return <Loader fullPage />;
  }
  //TBD: Mobile layout not decided yet
  //return isMobile ? <LayoutMobile /> : <LayoutDesktop />;
  return <LayoutDesktop />;
};

export default PublicLayout;
